import React from "react";
import { connect } from "react-redux";

import Col from "antd/es/col";
import Row from "antd/es/row";
import { useIntl } from "react-intl";

import { getEmailQuota } from "@app/store/email";
import { RootState } from "@app/store/rootReducer";

import TextWithInfo from "../typography/TextWithInfo";

import styles from "./EmailQuotaInfo.module.scss";

const EmailQuotaInfo = ({ emailQuota }: ReturnType<typeof mapStateToProps>) => {
  const intl = useIntl();

  if (!emailQuota) {
    return null;
  }

  return (
    <Row align="middle" justify="space-between">
      <Col className={styles.infoText}>
        <TextWithInfo
          info={intl.formatMessage(
            {
              id: "email.quotaInfo.text.tooltip",
              defaultMessage: "You can send up to {count} emails per day",
              description: "Third point tooltip in the email summary info.",
            },
            { count: emailQuota.total }
          )}
          placement="top"
        >
          {intl.formatMessage({
            id: "email.quotaInfo.text",
            defaultMessage: "Total sends left today",
            description: "Third point in the email summary info.",
          })}
        </TextWithInfo>
      </Col>
      <Col className={styles.infoValue}>
        {emailQuota.remaining} / {emailQuota.total}
      </Col>
    </Row>
  );
};

const mapStateToProps = (state: RootState) => ({
  emailQuota: getEmailQuota(state),
});

export default connect(mapStateToProps)(EmailQuotaInfo);
